import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Container} from "react-bootstrap";

import {Icon} from "../../../components/Icon";

export const Hero: FC = () => {
	const {t} = useTranslation();
	const trust = t("hero.trust") as unknown as string[];

	return (
		<section className="hero" id="hero">
			<Container>
				<div className="row align-items-center g-5">
					<div className="col-12 col-lg-6 text-center text-lg-start">
						<span className="hero__badge">{t("hero.badge")}</span>
						<h1 className="hero__title">{t("hero.title")}</h1>
						<p className="hero__subtitle">{t("hero.subtitle")}</p>
						<div className="hero__actions">
							{/* Disabled until the app goes live — see cta.comingSoon */}
							<button type="button" className="btn btn-primary btn-lg" disabled>
								{t("cta.startFree")}
							</button>
							<a className="btn btn-outline-primary btn-lg" href="#how-it-works">
								{t("cta.learnMore")}
							</a>
						</div>
						<p className="hero__coming">{t("hero.comingSoon")}</p>
						<ul className="hero__trust">
							{trust.map((item) => (
								<li key={item} className="hero__trust-item">
									<Icon name="check" className="hero__trust-icon" />
									{item}
								</li>
							))}
						</ul>
					</div>
					<div className="col-12 col-lg-6">
						<div className="hero__image">
							<img src="/images/hero-app.svg" alt={t("hero.imageAlt")} />
						</div>
					</div>
				</div>
			</Container>
		</section>
	);
};
